import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createCurriculum, createDocuments, deleteCurriculum, deleteDocument, fetchAllDocuments, updateCurriculum, updateDocuments } from "../../../service/api";





export const getAllDocuments = createAsyncThunk(
    "document/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAllDocuments(params)
            console.log("documents", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)



export const deleteDocuments = createAsyncThunk(
    "document/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteDocument(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addDocuments = createAsyncThunk(
    "document/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createDocuments(formValue)
            if (response.status === 201) {
                console.log("doc", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editDocuments = createAsyncThunk(
    "document/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateDocuments(formValue)
            if (response.status === 201) {
                console.log("document", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const documentSlice = createSlice({
    name: "document",
    initialState: {
        documentList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        status: "",
        room: "",
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },

        setRoomFilter: (state, action) => {
            state.room = action.payload;
        },
        setStatusFilter: (state, action) => {
            state.status = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            //curriculum plan
            .addCase(getAllDocuments.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getAllDocuments.fulfilled, (state, action) => {
                state.isLoading = false;
                state.documentList = action.payload.data;
                state.totalPage = action.payload.totalPages
            })

            .addCase(getAllDocuments.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // POST
            .addCase(addDocuments.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addDocuments.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addDocuments.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(deleteDocuments.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteDocuments.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteDocuments.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editDocuments.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editDocuments.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editDocuments.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})
export const { setPagination, setRoomFilter, setStatusFilter } = documentSlice.actions;

export default documentSlice.reducer;
